import { Icon, P, Stack, theme } from '@ovotech/element-v5';
import { Card } from '@ovotech/nebula';
import React from 'react';
import { PAGE_TITLE } from '../PAYGTopupHistoryPage';
import { Heading } from './TopupHistoryList.styled';

export const NoTransactionsView = () => (
  <Card>
    <Stack spaceBetween={3}>
      <Stack spaceBetween={4} orientation="horizontal">
        <Icon name="info" size={32} color={theme.color.alert.info} />
        <Heading>{PAGE_TITLE}</Heading>
      </Stack>
      <P>
        There’s no top-up history yet. Your first transaction will appear here
      </P>
    </Stack>
  </Card>
);
